
import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AuthContext } from '../../AuthProvider/Auth';
import SocialMedia from '../../Assets/Social-media-facebook-like-vector-PNG.png'
import { RotatingLines } from 'react-loader-spinner';

const SignUp = () => {

  const { register, formState: { errors }, handleSubmit } = useForm();

  const { createUser, updateUser } = useContext(AuthContext);
  const [loading, setLoading] = useState()
  const [signUpError, setSignupError] = useState('')
  const navigate = useNavigate();

  const months = [
    'January', 'February', 'March', 'April',
    'May', 'June', 'July', 'August',
    'September', 'October', 'November', 'December'
  ];

  const currentDate = new Date();
  const currentMonth = months[currentDate.getMonth()];
  const lastTwoDigitsOfYear = currentDate.getFullYear() % 100;
  const joinDate = `${currentMonth} '${lastTwoDigitsOfYear}`;

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };


  const handleSignup = data => {
    setLoading(true)
    createUser(data.email, data.password)
      .then(result => {
        const user = result.user;
        // console.log(user);
        const userInfo = {

          displayName: data.name
        }
        updateUser(userInfo)
          .then(() => {
            saveUser(data.name, data.email, data.password, data.type)
          })

          .catch(err => console.log(err))
      })
      .catch(err => {
        setSignupError(err.message);
        console.log(err.message);
      })
  }

  // user store data base 
  const saveUser = (name, email, password) => {

    const user = {
      name,
      email,
      password,
      joinDate: joinDate



    };

    fetch('https://e-somaz-server.vercel.app/users', {
      method: 'PUT',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify(user)
    })
      .then(res => res.json())
      .then(data => {
        console.log(data);
        setLoading(false)
        navigate('/home', { replace: true });
        window.location.reload();
        toast.success(" Welcome to eConnect ");

      })
  }




  return (
    // old sty;e
    // <div className='bg-gradient-to-t md:min-h-screen from-zinc-900 via-violet-600 to-indigo-600 py-24 md:py-20 text-white'>

    //   <div className="     rounded-2xl  max-w-[1000px] mx-auto  sm:rounded-2xl flex justify-center flex-1">
    //     <div className="lg:w-1/2 py-10">
    //       <div className="mt-2 flex flex-col items-center">
    //         <h1 className="text-2xl  font-bold">
    //          Create New Account
    //         </h1>
    //         <div className="w-full flex-1 mt-4">
    //           <div className="flex flex-col px-5 md:px-12 items-center">
    //           </div>
    //           <div className="mx-auto px-5 md:px-12 ">
    //             <form onSubmit={handleSubmit(handleSignup)}>
    //               <input
    //                 className="w-full mb-5 px-8  text-gray-600 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white"
    //                 type="text"
    // {...register("name", {
    //   required: "Name  is required"
    // })}
    //                 placeholder="Name"
    //               /> <span className='text-red-400 -mt-4 '> {errors.name && <p role="alert">{errors.name?.message}</p>}</span>
    //               <input
    //                 className="w-full  text-gray-600  px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white"
    //                 type="email"
    // {...register("email", {
    //   required: "Email Address is required"
    // })}
    //                 placeholder="Email"
    //               /> <span className='text-red-400 '> {errors.email && <p role="alert">{errors.email?.message}</p>}</span>
    //               <input
    //                 className="w-full  text-gray-600 px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5"
    //                 type="password"
    // {...register("password", {
    //   required: "Password is required",
    //   pattern: { value: /(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])/, message: 'Password must be more strong' },
    //   minLength: { value: 6, message: "Password must be 6 characters or longer" }
    // })}
    //                 placeholder="Password"
    //               />  <span className='text-red-400 '> {errors.password && <p role="alert">{errors.password?.message}</p>}</span>
    //               <br /> <br />
    //               {signUpError && <p className=' text-center font-bold text-red-400'>{signUpError}</p>}
    //               {
    //                 loading ? <button
    //                   className="mt-3 cursor-pointer tracking-wide font-semibold bg-indigo-500 text-gray-100 w-full py-4 rounded-lg hover:bg-indigo-700 transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none"><ThreeDots height="24" width="50" radius="9" color="white" ariaLabel="three-dots-loading" wrapperStyle={{}} wrapperClassName="" visible={true}
    //                   /></button> :
    //                   <button
    //                     className="mt-3 cursor-pointer tracking-wide font-semibold bg-indigo-500 text-gray-100 w-full py-4 rounded-lg hover:bg-indigo-700 transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none"
    //                     type='submit'>Sign Up</button>
    //               }
    //             </form>

    //             <p className='text-sm text-center mt-3  font-semibold text-white'>Already have account? <span className='text-white font-extrabold'> <Link to={'/signIn'}>Log In</Link> </span></p>

    //             {/* terms and policy */}
    //             <p className="mt-6 text-xs  text-center">
    //               <input type="checkbox" className=' cursor-pointer mr-2' />
    //               I agree to abide by eConnect
    //               <a href="#" className="border-b ml-1 mr-1 border-gray-500 border-dotted">
    //                 Terms of Service 
    //               </a>
    //               and its
    //               <a href="#" className="border-b ml-1 border-gray-500 border-dotted">
    //                 Privacy Policy
    //               </a>
    //             </p>
    //           </div>
    //         </div>
    //       </div>
    //     </div>

    //     <div className="flex-1    rounded-r-2xl  text-center hidden lg:flex">
    //       <div
    //         className="m-12  xl:m-16 w-full bg-[url('https://storage.googleapis.com/devitary-image-host.appspot.com/15848031292911696601-undraw_designer_life_w96d.svg')] r bg-contain bg-center bg-no-repeat"

    //       ></div>
    //     </div>
    //   </div>

    // </div>
    //  new style 
    <div className=" transition-all duration-700 py-36 xl:py-40 2xl:py-60 w-full md:w-[800px] lg:w-[900px] 2xl:w-[1200px] px-2 mx-auto md:flex">
      <div
        className="relative rounded-tl-2xl rounded-bl-2xl  overflow-hidden md:flex w-1/2 bg-gradient-to-tr from-blue-500 to-blue-700  justify-around items-center hidden">
        <img src={SocialMedia} alt="img" />

      </div>
      <div className="flex w-full px-5  md:px-10 rounded-2xl md:rounded-none md:rounded-tr-2xl md:rounded-br-2xl md:w-1/2 justify-center py-10 items-center bg-white">
        <form onSubmit={handleSubmit(handleSignup)} className="bg-white w-full max-w-md">
          <h1 className="text-gray-800 font-bold text-2xl mb-1">Create Account</h1>
          <p className="text-sm text-gray-600 font-semibold mb-7">
            Embark on your social journey with us!
          </p>

          {/* Full name input */}
          <div className="mb-4">
            <div className="flex items-center border-2 py-2 px-3 rounded-2xl">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd" />
              </svg>
              <input
                {...register("name", { required: "Name is required" })}
                className="pl-2 outline-none border-none w-full"
                type="text"
                placeholder="Full name"
              />
            </div>
            <span className="text-red-400"> {errors.name && <p role="alert">{errors.name?.message}</p>}</span>
          </div>

          {/* Email input */}
          <div className="mb-4">
            <div className="flex items-center border-2 py-2 px-3 rounded-2xl">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
              </svg>
              <input
                {...register("email", { required: "Email Address is required" })}
                className="pl-2 outline-none border-none w-full"
                type="text"
                placeholder="Email Address"
              />
            </div>
            <span className="text-red-400"> {errors.email && <p role="alert">{errors.email?.message}</p>}</span>
          </div>

          {/* Password input with show/hide functionality */}
          <div className="mb-4">
            <div className="flex items-center border-2 py-2 px-3 rounded-2xl relative">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd" />
              </svg>
              <input
                {...register("password", {
                  required: "Password is required",
                  pattern: { value: /(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])/, message: 'Password must be more strong' },
                  minLength: { value: 6, message: "Password must be 6 characters or longer" }
                })}
                className="pl-2 outline-none border-none w-full"
                type={showPassword ? "text" : "password"}
                placeholder="Password"
              />
              <button
                type="button"
                onClick={togglePasswordVisibility}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 focus:outline-none"
              >
                {showPassword ? <FaEye className="text-gray-500" /> : <FaEyeSlash className="text-gray-500" />}
              </button>
            </div>
            <span className="text-red-400"> {errors.password && <p role="alert">{errors.password?.message}</p>}</span>
          </div>

          {/* Submit button */}
          {loading ? (
            <button
              type="submit"
              className="flex gap-2 justify-center w-full bg-blue-500 hover:bg-blue-700 transition-colors mt-4 py-2 rounded-2xl text-white font-semibold mb-2"
            >
              Processing
              <RotatingLines
                strokeColor="white"
                strokeWidth="5"
                animationDuration="0.75"
                width="24"
                visible={true}
              />
            </button>
          ) : (
            <button
              type="submit"
              className="block w-full bg-blue-500 hover:bg-blue-700 transition-colors mt-4 py-2 rounded-2xl text-white font-semibold mb-2"
            >
              Sign Up
            </button>
          )}

          {/* Error message */}
          {signUpError && <p className="text-center font-bold text-red-400">{signUpError}</p>}

          {/* Already have an account link */}
          <p className="text-sm mt-3 ml-2 font-semibold text-gray-600">
            Already have an account? <span className="text-blue-700 font-extrabold"> <Link to={'/signIn'}>Log In</Link> </span>
          </p>
        </form>
      </div>
    </div>

  );
};

export default SignUp;